import { ReactNode } from 'react';
import { twMerge } from 'tailwind-merge'

interface NameBadgeProps {
  name: string;
  icon?: ReactNode;
  iconBgClassName?: string;
}

const NameBadge = ({ name, icon, iconBgClassName }: NameBadgeProps) => {
  return (
    <div className="flex items-center gap-2 mt-1">
      {icon &&
        <div className={twMerge(`flex items-center justify-center w-6 h-6 rounded-full bg-secondary-100 text-secondary-600 shrink-0`, iconBgClassName)}>
          {icon}
        </div>
      }

      <span className="text-xs font-medium text-secondary-600">{name}</span>
    </div>
  );
};

export default NameBadge;
